<template>
  <main class="container my-5">

    <div class="page-container">

      <div class="mb-4">

        <span class="text-primary fw-semibold">
          INVENTORY
        </span>

        <h2 class="fw-bold">
          Add New Book
        </h2>

        <p class="text-muted">
          Add a new book to your store.
        </p>

      </div>

      <BookForm
        submit-text="Add Book"
        @submit="addBook"
      />

    </div>

  </main>
</template>

<script>
import BookForm
  from '../components/BookForm/BookForm.vue'

export default {
  name: 'AddBook',

  components: {
    BookForm
  },

  methods: {
    async addBook(book) {
      const result =
        await this.$store.dispatch(
          'addBook',
          book
        )

      if (!result.success) {
        alert(
          result.message
        )

        return
      }

      alert(
        'Book added successfully!'
      )

      this.$router.push(
        '/books'
      )
    }
  }
}
</script>

<style scoped>
.page-container {
  max-width: 850px;

  margin: auto;

  background: white;

  padding: 35px;

  border-radius: 18px;

  box-shadow:
    0 5px 25px
    rgba(0, 0, 0, 0.06);
}
</style>